import getCollectionData from "../../utils/getCollectionData";

export default async function validateArticleISBN(db, { ref, isbn }) {
	if (isbn) {
		const articles = await getCollectionData(
			db.collection("articles").where("isbn", "==", isbn).where("deleted", "==", false).limit(2),
		);

		if (articles.find((article) => article.id !== ref.id)) {
			throw new Error("An article with the same ISBN already exists");
		}
	}
}
